import { render, staticRenderFns } from "./IInput.vue?vue&type=template&id=36caa6ce&"
import script from "./IInput.vue?vue&type=script&lang=js&"
export * from "./IInput.vue?vue&type=script&lang=js&"
import style0 from "./IInput.vue?vue&type=style&index=0&id=36caa6ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports